import React, { memo, forwardRef } from "react";
const SvgNotasuperset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9.768 24.876a1 1 0 101.732 1l1.287-2.229H16a8 8 0 005.008-14.239L22.5 6.824a1 1 0 00-1.732-1l-1.464 2.535A7.971 7.971 0 0016 7.647H9a1 1 0 100 2h7c.814 0 1.59.162 2.297.456l-6.665 11.544H9a1 1 0 100 2h1.478l-.71 1.23zm4.174-3.229H16a6 6 0 003.992-10.48l-6.05 10.48z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNotasuperset.displayName = "SvgNotasuperset";
const MemoForwardRef = memo(SvgNotasuperset);
export default MemoForwardRef;
